import React from "react";
import Download from "../XplanComponents/Download";
import Upload from "../PullListComponents/Upload";
import HistoryLogElement from "./HistoryLogElement";
import { renderGroupComponent } from "../../util/FormUtils";

const DownloadUploadFields = ({ category, handleFileChange, form, allowedRoles, tag, required, disabled }) => {
    return (
        <div className="planField">
            {renderGroupComponent(tag)}
            <div style={{ display: "flex", flexDirection: "column" }}>
                <Upload
                    category={category}
                    handleFileChange={handleFileChange}
                    form={form}
                    allowedRoles={allowedRoles}
                    required={required}
                    disabled={disabled ? disabled : false}
                />
                <Download fileId={form.data[`${category}`]} category={category} />
            </div>
            <HistoryLogElement pullLists={form.pullLists} label={`${category}Version`} />
        </div>
    );
};

export default DownloadUploadFields;
